export default "__VITE_ASSET__CmB5KYOM__"